import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";

export default function YouthIssues() {
  const issues = [
    "1 in 4 children live in a fatherless home",
    "1 in 4 teen girls has at least one STD",
    "47% of youth use an illegal drug by the time they graduate high school",
    "1 in 4 women will have an abortion by the age of 45",
    "Average age of first exposure to pornography is 11",
    "The second leading cause of death for people aged 15-24 is suicide",
    "1 in 3 adolescents is a victim of abuse from a dating partner (sexual, physical, emotional, verbal)"
  ];

  return (
    <section className="bg-gradient-to-b from-white to-blue-50 py-16">
      <div className="mx-auto max-w-6xl px-6">
        <div className="mb-12 text-center">
          <div className="mb-4 flex items-center justify-center">
            <div className="rounded-full bg-red-100 p-3">
              <FaExclamationTriangle className="text-3xl text-red-600" />
            </div>
          </div>
          <h2 className="mb-4 text-3xl font-bold text-gray-800 md:text-4xl">
            Critical Issues Youth Are Facing
          </h2>
          <div className="mx-auto h-1 w-24 rounded bg-[#457B9D]"></div>
          <p className="mt-6 text-lg text-gray-600">
            The need for proactive education has never been more urgent
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {issues.map((issue, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-2xl bg-white p-6 shadow-md transition-all duration-300 hover:shadow-xl"
            >
              <div className="absolute right-4 top-4 opacity-10 transition-opacity duration-300 group-hover:opacity-20">
                <FaExclamationTriangle className="text-4xl text-[#457B9D]" />
              </div>
              <div className="relative">
                <div className="mb-3 flex h-8 w-8 items-center justify-center rounded-full bg-[#457B9D] text-sm font-bold text-white">
                  {index + 1}
                </div>
                <p className="text-base leading-relaxed text-gray-700">{issue}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-2xl bg-gradient-to-r from-red-50 to-orange-50 p-8 text-center">
          <p className="text-lg font-semibold text-gray-800 md:text-xl">
            These statistics underscore the critical importance of early intervention and comprehensive youth education programs.
          </p>
        </div>
      </div>
    </section>
  );
}
